export * from './product';

export const isEmpty = (val: any) => val === undefined || val === null || val === '';
